import ProjectSession from "../../project-session";
import {openLink} from "../../../../gd/utils/gd-system-link";


export function projectLinkGoTo(project: ProjectSession) {

    if (project.properties.url) {


        return openLink(project.properties.url)


        // if (isGDSystemLink(project.properties.url)) {
        //     return openGDSystemLink(project.properties.url)
        // }
        //
        // const isFullLink = project.properties.url.substring(0,4) === 'http'
        //
        // window.open('{0}{1}'.f(isFullLink ? '' : 'https://', project.properties.url))
        //
        // return

    }

    if (project.acl.hasFullAccess) {
        gd.navigation.goToProject(project.id, '/link/edit')
        return
    }

    gd.growl.error("No link URL specified.")


}